;(function($) {

	$(document).ready(function() {
		$('iframe[src*="youtube.com"]').wrap('<div class="responsive-video"></div>');
		$('iframe[src*="youtube-nocookie.com"]').wrap('<div class="responsive-video"></div>');
		$('iframe[src*="player.vimeo.com"]').wrap('<div class="responsive-video"></div>');
		$('iframe[src*="my.matterport.com"]').wrap('<div class="responsive-video"></div>');
	});
	
})(jQuery);